module.exports = __webpack_public_path__ + "static/media/partner-logo8.2d873e96.png";